module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-photo-data-50e7185791dbd375f9329929684c8d86.png";